import { gql } from '@apollo/client'

export const RATE_PLAN_GENERATE_JOB_HANDLER_SUBSCRIPTION = gql`
  subscription MultipleRatePlanJobHandler($trackingID: String!) {
    MultipleRatePlanJobHandler(trackingID: $trackingID) {
      code
      status
    }
  }
`
